module.exports = __webpack_public_path__ + "static/media/Complicity.1b5145bc.jpg";